import React, { Component } from "react";
import Form from "react-bootstrap/Form";

class UpdateUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = { showPassword: false };
  }

  render() {
    const {
      editedUser,
      isLoading,
      userError,
      updateUser,
      handleUserInfoChange,
      securityOptions,
    } = this.props;

    return (
      <div className="auth-wrap">
        <div className="auth-col">
          <form onSubmit={(e) => e.preventDefault()} className="login">
            <p className="contactform-field contactform-text">
              <label htmlFor="given_name">First Name:</label>
              <input
                type="text"
                id="given_name"
                name="given_name"
                value={editedUser.given_name}
                onChange={(e) => handleUserInfoChange("given_name", e)}
              />
            </p>
            <p className="contactform-field contactform-text">
              <label htmlFor="family_name">Last Name:</label>
              <input
                type="text"
                id="family_name"
                name="family_name"
                value={editedUser.family_name}
                onChange={(e) => handleUserInfoChange("family_name", e)}
              />
            </p>
            <p className="contactform-field contactform-text">
              <label htmlFor="password">Password:</label>
              <input
                type={this.state.showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={editedUser.password}
                onChange={(e) => handleUserInfoChange("password", e)}
              />

              <label htmlFor="show-password">Show Password:</label>
              <input
                type="checkbox"
                id="show-password"
                checked={this.state.showPassword}
                onChange={(e) => {
                  this.setState({ showPassword: !this.state.showPassword });
                }}
              />
            </p>

            <p className="contactform-field contactform-text">
              <label className="contactform-label" htmlFor="security">
                Security:
              </label>
              <span className="contactform-input">
                <Form.Control
                  id="security"
                  as="select"
                  value={editedUser.security}
                  onChange={(e) => handleUserInfoChange("security", e)}
                >
                  {securityOptions.map((option, index) => (
                    <>
                      <option key={index} value={option}>
                        {option}
                      </option>
                    </>
                  ))}
                </Form.Control>
              </span>
            </p>

            <p className="auth-submit">
              <button onClick={updateUser} disabled={isLoading}>
                Update User
              </button>
            </p>
          </form>

          {userError && (
            <div className="err404">
              <p className="err404-search">{userError}</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default UpdateUserForm;